import { HardwareInsuranceOption } from '../modules/mobilephone/models/mobilephone-search-item';
import { Product } from '@shared/models/product.model';
import { MobilePaymentType } from '../enums/mobile-payment-type';
import { HardwareVariant } from '../modules/mobilephone/models/mobilephone-variant';

export class MobilePhoneProduct extends Product {
  mobilePhoneVariant: HardwareVariant;
  isManualRegistration: boolean;
  isExternalCellPhone: boolean;
  sendInPost: boolean;
  gtin: string;
  imei: string;
  isMissingIdentifiers: boolean;
  name: string;
  voiceProductId: string;
  paymentType: MobilePaymentType;
  existingAgreementId: string;
  insuranceOption: HardwareInsuranceOption;
  mobilBytteOffering?: string;
}
